import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routers'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes
})
router.beforeEach((to, from, next) => {
  if (Number(process.env.VUE_APP_HIDE_COURSE_TAB) === 1 && to.name === 'CourseList') {
    next({ path: '/lecture' })
  } else {
    next()
  }
})
export default router
